// extracted by mini-css-extract-plugin
export default {"title":"styles_title__jlJgl","accent":"styles_accent__Gdkwm","submitButton":"styles_submitButton__3syPH","helpSection":"styles_helpSection__RDTPE"};